import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import "./custom-client-selector.css";
import { getCustomsClients } from "../../utils";
import { forceColor } from "../../actions/AuthAction";
import { Layout, Avatar, Menu, Dropdown } from 'antd';
import { deleteToken } from "../../api/AuthApi";
import { Spin } from "antd";
import 'antd/dist/antd.css';
import {
  getClientById,
  getBreadCrumbsByClient,
  getUserClientRole
} from "../../actions/ClientAction";
import { getDefaultPermissions } from "../../actions/GroupAction";

const { Header, Content } = Layout;

export class CustomClientSelector extends Component {

  constructor(props) {
    super(props);
    this.clients = getCustomsClients()
    this.state = {
      isLoading: false,
      showUserMenu: false,
      defaultAvatar: "/images/icons/user-icon.svg",
    };
    this.isSuperAdmin = false;
    this.menu = (
      <Menu>
        <Menu.Item key="0" onClick={() => this.handleUserLogOut()}>
          Cerrar sesión
        </Menu.Item>
      </Menu>
    );
  }

  componentDidMount() {
    const { avatar, user } = this.props;

    if (user && user.workClients.length === 1) {
      this.handleOnClick(this.clients.find(client => client._id === user.workClients[0]))
    } else if (user && user.workClients.length === 0) {
      this.isSuperAdmin = true;
    }
    if (avatar) {
      this.setState({
        defaultAvatar: avatar
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isDone && !prevProps.isDone) {
      this.props.history.push("/home");
    }
  }


  handleOnClick = client => {
    const { _id, color } = client;
    this.setState(
      {
        isLoading: true
      },
      () => {
        this.props.getClientById(_id).then(() => {
          this.props.forceColor(color)
          this.props.getDefaultPermissions()
          this.props.getUserClientRole(_id)
          this.props.getBreadCrumbsByClient(_id)

        });
      }
    );
  }

  handleShowUserMenu = () => {
    const { showUserMenu } = this.state;
    this.setState({ showUserMenu: !showUserMenu });
  };

  handleUserLogOut = () => {
    deleteToken()
      .then(res => this.props.history.push("/logout"))
      .catch(err => {
        console.log(err);
        this.props.history.push("/logout");
      });
  };

  render() {
    const { defaultAvatar, isLoading } = this.state;
    const { user } = this.props;
    const userFirstName = user && user.name ? user.name.split(" ")[0] : "";
    return (
      <Layout>
        <Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "1200px", margin: "0 auto" }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src="/gnbrands/gn-logo-and-brands.png" width={180} alt="gnbrands" />
            </div>
            <div onClick={this.handleShowUserMenu} style={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}>
              <Dropdown overlay={this.menu} trigger={['click']}>
                <div>
                  <span style={{ marginRight: 10, color: "#fff" }}>{userFirstName}</span>
                  <Avatar src={defaultAvatar} style={{ borderRadius: '50%' }} />
                </div>
              </Dropdown>
            </div>
          </div>
        </Header>
        <Content>
          {isLoading &&
            <div className="custom-client-images-loading">
              <Spin style={{ width: "100%" }} spinning={true} />
            </div>
          }
          <div className="custom-client-images">
            {this.isSuperAdmin && this.clients.map((client, key) => <img key={key} onClick={() => this.handleOnClick(client)} src={client.imgSelector} alt={client.name} />)}
            {!this.isSuperAdmin && this.clients.filter(r => user.workClients.includes(r._id)).map((client, key) => <img key={key} onClick={() => this.handleOnClick(client)} src={client.imgSelector} alt={client.name} />)}
          </div>
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isDone: state.client.isDone,
    user: state.authUser.user,
    avatar: state.authUser.user.avatar,
  };
};

const mapDispatchToProps = {
  forceColor,
  getClientById,
  getDefaultPermissions,
  getUserClientRole,
  getBreadCrumbsByClient
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomClientSelector))
);
